import React, { FC } from 'react';
import { HorizontalSlider } from '@components/atoms/HorizontalSlider';
import { ProductCard, ProductCardProps } from '@components/molecules/ProductCard';

export interface ProductsHorizontalSliderProps {
    products: ProductCardProps[];
}

export const ProductsHorizontalSlider: FC<ProductsHorizontalSliderProps> = ({ products }) => {
    return (
        <HorizontalSlider
            breakpointsStyles={{
                xs: { height: '25.75em', itemsGap: '32px', itemsWidth: '17.5em' },
                xxl: { itemsWidth: '18.625em' },
            }}>
            {products.map((product, index) => (
                <ProductCard key={`product-${index}`} {...product} truncateTitle={true} />
            ))}
        </HorizontalSlider>
    );
};
